export default "__VITE_ASSET__DzNJfbHj__"